import { render } from "./MenuUserModuleConfiguration.vue?vue&type=template&id=3e8e8f4c&scoped=true"
import script from "./MenuUserModuleConfiguration.vue?vue&type=script&lang=js"
export * from "./MenuUserModuleConfiguration.vue?vue&type=script&lang=js"

import "./MenuUserModuleConfiguration.vue?vue&type=style&index=0&id=3e8e8f4c&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e8e8f4c"]])

export default __exports__